<ng-container *ngIf="mostrarPublicidadIntersticial && !isMobile">
  <aside class="publicidadIntersticial" aria-label="Publicidad Intersticial">
    <a [href]="publicidadInstertsticial?.enlace" *ngIf="publicidadInstertsticial?.esIframe == 0 || !publicidadInstertsticial?.esIframe">
      <img [src]="publicidadInstertsticial?.img" [alt]="publicidadInstertsticial?.titulo" />
    </a>
    <iframe *ngIf="publicidadInstertsticial?.esIframe == 1" [src]="publicidadInstertsticial?.urlIframe | safeResourceUrl" width="800" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
    <button mat-button class="btnCerrarInstersticial" (click)="cerrarPublicidadIntersticial()">Cerrar Publicidad ({{ temporizadorCierreIntersticial }})</button>
  </aside>
</ng-container>

<ng-container *ngIf="mostrarPublicidadIntersticialMovil && isMobile">
  <aside class="publicidadIntersticial" aria-label="Publicidad Intersticial Movil">
    <a [href]="publicidadInstertsticialMovil?.enlace" *ngIf="publicidadInstertsticialMovil?.esIframe == 0 || !publicidadInstertsticialMovil?.esIframe">
      <img [src]="publicidadInstertsticialMovil?.img" [alt]="publicidadInstertsticialMovil?.titulo" />
    </a>
    <iframe *ngIf="publicidadInstertsticialMovil?.esIframe == 1" [src]="publicidadInstertsticialMovil?.urlIframe | safeResourceUrl" width="300" height="250" frameborder="0" scrolling="no" title="Publicidad Movil"></iframe>
    <button mat-button class="btnCerrarInstersticial" (click)="cerrarPublicidadIntersticial()">Cerrar Publicidad ({{ temporizadorCierreIntersticial }})</button>
  </aside>
</ng-container>

<app-header></app-header>

<app-modal-politica-co (reject)="reject()" (accept)="accept($event)" [config]="consents" *ngIf="consentType === 'normal' && (consents.init === false || consents.config === true) && mostrarConsent"></app-modal-politica-co>
<app-cookie-consent-sub *ngIf="consentType === 'sub'"></app-cookie-consent-sub>

<main class="home-contenedor" id="home-contenedor" [ngStyle]="publicidadFondoCompleto?.img && !isMobile ? { 'background-image': 'url(' + publicidadFondoCompleto?.img + ')' } : null" [ngClass]="{ 'fondo-publicidad-full': publicidadFondoCompleto?.img && !isMobile, 'noticias-reels': pageReels, 'pagina-noticia': pageNoticia }">
  <section class="contenedor-publicidad contenedor-publicidad-sky sky-l">
    <ng-container *ngIf="!isInIframe">
      <div style="min-width: 120px; min-height: 600px" class="publi-lateral publicidad-no-sticky">
        <!-- ARRIBA: Exterior + Interior lado a lado -->

        <!-- COLUMNA EXTERIOR ARRIBA -->
        <ng-container *ngIf="publicidadIzquierdaExterior?.enlace; else fallbackIzqExterior">
          <a [href]="publicidadIzquierdaExterior?.enlace" target="_blank">
            <iframe *ngIf="publicidadIzquierdaExterior?.esIframe == 1" [src]="publicidadIzquierdaExterior?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
            <div *ngIf="publicidadIzquierdaExterior?.esIframe == 0">
              <img *ngIf="publicidadIzquierdaExterior?.esVideo == 0" [src]="publicidadIzquierdaExterior?.img" alt="ads" width="100%" height="100%" loading="lazy" />
              <video *ngIf="publicidadIzquierdaExterior?.esVideo == 1" width="100%" autoplay controls [muted]="'muted'">
                <source [src]="publicidadIzquierdaExterior?.img" type="video/mp4" />
              </video>
            </div>
          </a>
        </ng-container>

        <!-- COLUMNA INTERIOR ARRIBA -->
        <ng-container *ngIf="publicidadIzquierdaInterior?.enlace; else fallbackIzqInterior">
          <a [href]="publicidadIzquierdaInterior?.enlace" target="_blank">
            <iframe *ngIf="publicidadIzquierdaInterior?.esIframe == 1" [src]="publicidadIzquierdaInterior?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
            <div *ngIf="publicidadIzquierdaInterior?.esIframe == 0">
              <img *ngIf="publicidadIzquierdaInterior?.esVideo == 0" [src]="publicidadIzquierdaInterior?.img" alt="ads" width="100%" height="100%" loading="lazy" />
              <video *ngIf="publicidadIzquierdaInterior?.esVideo == 1" width="100%" autoplay controls [muted]="'muted'">
                <source [src]="publicidadIzquierdaInterior?.img" type="video/mp4" />
              </video>
            </div>
          </a>
        </ng-container>

        <!-- FALLBACK combinado para la izquierda -->
        <ng-template #fallbackIzqExterior>
          <div id="SKY_L_SUP" class="publicidad-no-sticky"></div>
          <div id="SKY_L_INF" class="publicidad-no-sticky"></div>
          <div id="SKY_L_INF2" class="publicidad-no-sticky"></div>
          <div id="SKY_L_INF3" class="publicidad-no-sticky"></div>
        </ng-template>

        <!-- ABAJO: Exterior + Interior lado a lado -->

        <!-- COLUMNA EXTERIOR ABAJO -->
        <ng-container *ngIf="publicidadIzquierdaExteriorAbajo?.enlace">
          <a [href]="publicidadIzquierdaExteriorAbajo?.enlace" target="_blank">
            <iframe *ngIf="publicidadIzquierdaExteriorAbajo?.esIframe == 1" [src]="publicidadIzquierdaExteriorAbajo?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
            <ng-container *ngIf="publicidadIzquierdaExteriorAbajo?.esIframe == 0">
              <img *ngIf="publicidadIzquierdaExteriorAbajo?.esVideo == 0" [src]="publicidadIzquierdaExteriorAbajo?.img" alt="ads2" width="100%" height="100%" loading="lazy" />
              <video *ngIf="publicidadIzquierdaExteriorAbajo?.esVideo == 1" width="100%" autoplay controls [muted]="'muted'">
                <source [src]="publicidadIzquierdaExteriorAbajo?.img" type="video/mp4" />
              </video>
            </ng-container>
          </a>
        </ng-container>

        <ng-container *ngIf="publicidadIzquierdaExteriorAbajo?.tag_iframe">
          <iframe title="Publicidad" [src]="publicidadIzquierdaExteriorAbajo?.tag_iframe | safeResourceUrl" WIDTH="1" HEIGHT="1" MARGINWIDTH="0" MARGINHEIGHT="0" HSPACE="0" VSPACE="0" FRAMEBORDER="0" SCROLLING="no" BORDERCOLOR="#000000"></iframe>
        </ng-container>

        <!-- COLUMNA INTERIOR ABAJO -->
        <ng-container *ngIf="publicidadIzquierdaInteriorAbajo?.enlace">
          <a [href]="publicidadIzquierdaInteriorAbajo?.enlace" target="_blank">
            <iframe *ngIf="publicidadIzquierdaInteriorAbajo?.esIframe == 1" [src]="publicidadIzquierdaInteriorAbajo?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
            <ng-container *ngIf="publicidadIzquierdaInteriorAbajo?.esIframe == 0">
              <img *ngIf="publicidadIzquierdaInteriorAbajo?.esVideo == 0" [src]="publicidadIzquierdaInteriorAbajo?.img" alt="ads2" width="100%" height="100%" loading="lazy" />
              <video *ngIf="publicidadIzquierdaInteriorAbajo?.esVideo == 1" width="100%" autoplay controls [muted]="'muted'">
                <source [src]="publicidadIzquierdaInteriorAbajo?.img" type="video/mp4" />
              </video>
            </ng-container>
          </a>
        </ng-container>

        <ng-container *ngIf="publicidadIzquierdaInteriorAbajo?.tag_iframe">
          <iframe title="Publicidad" [src]="publicidadIzquierdaInteriorAbajo?.tag_iframe | safeResourceUrl" WIDTH="1" HEIGHT="1" MARGINWIDTH="0" MARGINHEIGHT="0" HSPACE="0" VSPACE="0" FRAMEBORDER="0" SCROLLING="no" BORDERCOLOR="#000000"></iframe>
        </ng-container>
      </div>
    </ng-container>
  </section>
  <section class="center-container">
    <div class="contenedor-publicidad contenedor-publicidad-header" id="HOME-CABECERA-SKIN"></div>
    <section class="contenedor-publicidad contenedor-publicidad-header" id="HOME-CABECERA">
      <div style="margin: 0 auto; width: 100%" *ngIf="!isInIframe">
        <ng-container *ngIf="publicidadCabecera?.enlace">
          <a [href]="publicidadCabecera?.enlace" target="_blank">
            <iframe [src]="publicidadCabecera?.urlIframe | safeResourceUrl" width="{{ publicidadCabecera?.width }}" height="{{ publicidadCabecera?.height }}" frameborder="0" scrolling="no" *ngIf="publicidadCabecera?.esIframe == 1"></iframe>
            <div *ngIf="publicidadCabecera?.esIframe == 0">
              <img [src]="publicidadCabecera?.img" style="width: 100%" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadCabecera?.esVideo == 0" />
              <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadCabecera?.esVideo == 1">
                <source [src]="publicidadCabecera?.img" type="video/mp4" />
              </video>
            </div>
          </a>
        </ng-container>
      </div>
    </section>

    <section class="contenedor-noticias" [ngClass]="{ 'fondo-publicidad-full': publicidadFondoCompleto?.img }">
      <router-outlet (activate)="stopTTS()"></router-outlet>
      <ng-container *ngIf="isShow">
        <div class="contenedor-publicidad contenedor-publicidad-footer">
          <div *ngIf="(!isInIframe && publicidadFooter?.enlace) || flotante_footer">
            <button class="close-pub" type="button" (click)="featureHide()">x</button>
            <div id="FLOOR_AD" #publiFLOOR style="min-width: 300px; min-height: 50px"></div>
            <div style="min-width: 300px">
              <a [href]="publicidadFooter?.enlace" target="_blank">
                <iframe [src]="publicidadFooter?.urlIframe | safeResourceUrl" width="980" height="90" frameborder="0" scrolling="no" *ngIf="publicidadFooter?.esIframe == 1"></iframe>
                <div *ngIf="publicidadFooter?.esIframe == 0">
                  <img [src]="publicidadFooter?.img" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadFooter?.esVideo == 0" />
                  <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadFooter?.esVideo == 1">
                    <source [src]="publicidadFooter?.img" type="video/mp4" />
                  </video>
                </div>
              </a>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isShow">
        <div class="contenedor-publicidad contenedor-publicidad-footer-movil">
          <div *ngIf="(!isInIframe && publicidadFooterMovil?.enlace) || flotante_footer">
            <button class="close-pub" type="button" (click)="featureHide()">x</button>
            <div id="Floor_Mobile" style="min-width: 300px; min-height: 50px"></div>
            <div style="min-width: 300px">
              <a [href]="publicidadFooterMovil?.enlace" target="_blank">
                <iframe [src]="publicidadFooterMovil?.urlIframe | safeResourceUrl" width="{{ publicidadFooterMovil?.width }}" height="{{ publicidadFooterMovil?.height }}" frameborder="0" scrolling="no" *ngIf="publicidadFooterMovil?.esIframe == 1"></iframe>
                <div *ngIf="publicidadFooterMovil?.esIframe == 0">
                  <img [src]="publicidadFooterMovil?.img" alt="ads" loading="lazy" width="100%" height="100%" *ngIf="publicidadFooterMovil?.esVideo == 0" />
                  <video style="width: 100%" width="100%" height="100%" autoplay controls [muted]="'muted'" *ngIf="publicidadFooterMovil?.esVideo == 1">
                    <source [src]="publicidadFooterMovil?.img" type="video/mp4" />
                  </video>
                </div>
              </a>
            </div>
          </div>
        </div>
      </ng-container>
    </section>
  </section>

  <section class="contenedor-publicidad contenedor-publicidad-sky sky-r">
    <ng-container *ngIf="!isInIframe">
      <div style="min-width: 120px; min-height: 600px" class="publi-lateral publicidad-no-sticky">
        <!-- ARRIBA: Exterior + Interior lado a lado -->

        <!-- COLUMNA EXTERIOR ARRIBA -->
        <ng-container *ngIf="publicidadDerechaExterior?.enlace; else fallbackDerExterior">
          <a [href]="publicidadDerechaExterior?.enlace" target="_blank">
            <iframe *ngIf="publicidadDerechaExterior?.esIframe == 1" [src]="publicidadDerechaExterior?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
            <ng-container *ngIf="publicidadDerechaExterior?.esIframe == 0">
              <img *ngIf="publicidadDerechaExterior?.esVideo == 0" [src]="publicidadDerechaExterior?.img" alt="ads" width="100%" height="100%" loading="lazy" />
              <video *ngIf="publicidadDerechaExterior?.esVideo == 1" width="100%" autoplay controls [muted]="'muted'">
                <source [src]="publicidadDerechaExterior?.img" type="video/mp4" />
              </video>
            </ng-container>
          </a>
        </ng-container>

        <!-- COLUMNA INTERIOR ARRIBA -->
        <ng-container *ngIf="publicidadDerechaInterior?.enlace; else fallbackDerInterior">
          <a [href]="publicidadDerechaInterior?.enlace" target="_blank">
            <iframe *ngIf="publicidadDerechaInterior?.esIframe == 1" [src]="publicidadDerechaInterior?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
            <ng-container *ngIf="publicidadDerechaInterior?.esIframe == 0">
              <img *ngIf="publicidadDerechaInterior?.esVideo == 0" [src]="publicidadDerechaInterior?.img" alt="ads" width="100%" height="100%" loading="lazy" />
              <video *ngIf="publicidadDerechaInterior?.esVideo == 1" width="100%" autoplay controls [muted]="'muted'">
                <source [src]="publicidadDerechaInterior?.img" type="video/mp4" />
              </video>
            </ng-container>
          </a>
        </ng-container>

        <!-- FALLBACK combinado para la derecha -->
        <ng-template #fallbackDerExterior>
          <div id="SKY_R_SUP" class="publicidad-no-sticky"></div>
          <div id="SKY_R_INF" class="publicidad-no-sticky"></div>
          <div id="SKY_R_INF2" class="publicidad-no-sticky"></div>
          <div id="SKY_R_INF3" class="publicidad-no-sticky"></div>
        </ng-template>

        <!-- ABAJO: Exterior + Interior lado a lado -->

        <!-- COLUMNA EXTERIOR ABAJO -->
        <ng-container *ngIf="publicidadDerechaExteriorAbajo?.enlace">
          <a [href]="publicidadDerechaExteriorAbajo?.enlace" target="_blank">
            <iframe *ngIf="publicidadDerechaExteriorAbajo?.esIframe == 1" [src]="publicidadDerechaExteriorAbajo?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
            <ng-container *ngIf="publicidadDerechaExteriorAbajo?.esIframe == 0">
              <img *ngIf="publicidadDerechaExteriorAbajo?.esVideo == 0" [src]="publicidadDerechaExteriorAbajo?.img" alt="ads" width="100%" height="100%" loading="lazy" />
              <video *ngIf="publicidadDerechaExteriorAbajo?.esVideo == 1" width="100%" autoplay controls [muted]="'muted'">
                <source [src]="publicidadDerechaExteriorAbajo?.img" type="video/mp4" />
              </video>
              <iframe title="Publicidad" [src]="publicidadDerechaExteriorAbajo?.tag_iframe | safeResourceUrl" WIDTH="1" HEIGHT="1" MARGINWIDTH="0" MARGINHEIGHT="0" HSPACE="0" VSPACE="0" FRAMEBORDER="0" SCROLLING="no" BORDERCOLOR="#000000" *ngIf="publicidadDerechaExteriorAbajo?.tag_iframe"></iframe>
            </ng-container>
          </a>
        </ng-container>

        <!-- COLUMNA INTERIOR ABAJO -->
        <ng-container *ngIf="publicidadDerechaInteriorAbajo?.enlace">
          <a [href]="publicidadDerechaInteriorAbajo?.enlace" target="_blank">
            <iframe *ngIf="publicidadDerechaInteriorAbajo?.esIframe == 1" [src]="publicidadDerechaInteriorAbajo?.urlIframe | safeResourceUrl" width="300" height="600" frameborder="0" scrolling="no" title="Publicidad"></iframe>
            <ng-container *ngIf="publicidadDerechaInteriorAbajo?.esIframe == 0">
              <img *ngIf="publicidadDerechaInteriorAbajo?.esVideo == 0" [src]="publicidadDerechaInteriorAbajo?.img" alt="ads" width="100%" height="100%" loading="lazy" />
              <video *ngIf="publicidadDerechaInteriorAbajo?.esVideo == 1" width="100%" autoplay controls [muted]="'muted'">
                <source [src]="publicidadDerechaInteriorAbajo?.img" type="video/mp4" />
              </video>
              <iframe title="Publicidad" [src]="publicidadDerechaInteriorAbajo?.tag_iframe | safeResourceUrl" WIDTH="1" HEIGHT="1" MARGINWIDTH="0" MARGINHEIGHT="0" HSPACE="0" VSPACE="0" FRAMEBORDER="0" SCROLLING="no" BORDERCOLOR="#000000" *ngIf="publicidadDerechaInteriorAbajo?.tag_iframe"></iframe>
            </ng-container>
          </a>
        </ng-container>
      </div>
    </ng-container>
  </section>
</main>

<app-footer *ngIf="showFooter" (cookies)="reconfigureCookies()"></app-footer>
